export default "__VITE_ASSET__b6e83ff4__"